module.exports = __webpack_public_path__ + "img/u2586.1353d94e.png";